import React from 'react';
import ContentLoader from 'react-content-loader';
import './TermsPrivacy.scss';

const ServicesPageLoader = () => {
  return (
    <ContentLoader className="disclaimer-loader" height={70}>
      <rect className="placeholder-rect-1" />
      <rect className="placeholder-rect-2" />
      <rect className="placeholder-rect-3" />
      <rect className="placeholder-rect-4" />
    </ContentLoader>
  );
};

export default ServicesPageLoader;



// WEBPACK FOOTER //
// ./src/components/pages/components/ContentFooter/components/TermsPrivacy/TermsPrivacyLoader.js